export const userFieldErrors = {
  email: "The email address you entered is already in use by another guest.",
  phone_number: "The phone number you entered is already in use by another guest.",
}
